var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Undo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.5,8.2l0.8-0.8c0.3-0.3,0.3-0.8,0-1.1c-0.3-0.3-0.8-0.3-1.1,0l-0.8,0.8c-1.3-1.1-2.9-1.8-4.7-1.9c0,0,0-0.1,0-0.1V3.5 h0.9c0.4,0,0.8-0.3,0.8-0.8S14,2,13.6,2h-3.2C10,2,9.6,2.4,9.6,2.8s0.3,0.8,0.8,0.8h0.9v1.5c0,0,0,0.1,0,0.1 c-4.3,0.4-7.7,4-7.7,8.4c0,4.6,3.8,8.4,8.4,8.4s8.4-3.8,8.4-8.4C20.4,11.5,19.7,9.6,18.5,8.2z M12,20.5c-3.8,0-6.9-3.1-6.9-6.9 c0-3.8,3.1-6.9,6.9-6.9s6.9,3.1,6.9,6.9C18.9,17.4,15.8,20.5,12,20.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5,9.9L11.5,13c-0.3,0.3-0.3,0.8,0,1.1c0.1,0.1,0.3,0.2,0.5,0.2s0.4-0.1,0.5-0.2l3.1-3.1c0.3-0.3,0.3-0.8,0-1.1 S14.8,9.6,14.5,9.9z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.a93943a1.svg";
export { ForwardRef as ReactComponent };